

<template>
  <div>

    <v-layout wrap >
      <!-- <v-row justify="center"></v-row> -->
        <v-flex xs12  justify-center >
          <h1 id="code_answer_title1" style="text-align:center;margin-bottom:8px;">INDICATEUR DE PRODUCTIVITE DU MOIS DE {{this.listReporting.tab_dates ? (this.listReporting.tab_dates[0]) : ''}} </h1>
          <v-divider class="mb-2"></v-divider>
        </v-flex>
    </v-layout>
    <br/>
      <div class="text-xs-center">
      <v-layout row>
        <v-flex>
            <el-button
              class="tooltip-btn"
              title="Imprimer l'indicateur de productivite"
              type="warning"
              icon="el-icon-printer"   
              @click="imprimeListeBilan()"
              >Imprimer en PDF
            </el-button>
        </v-flex>
      </v-layout>
    </div>
    <br/>

    <Loading :value="loading"></Loading>
    <v-layout row>
      <v-flex xs3 class="mb-2 mr-1">
        <v-card color="brown darken-1" class="white--text elevation-5">
        <h1 id="code_answer_title1" style="text-align:center;margin-bottom:8px;">DEMANDES DE FONDS</h1>
          <v-container fluid grid-list-lg>
            <v-layout row>
              <v-flex xs5>
                <div>
                  <div class="headline">
                    {{
                      this.listReporting.nbDemdFaPayerCaiss.length != 0
                        ? this.listReporting.nbDemdFaPayerCaiss[0]["somme"]
                        : 0
                    }}
                  </div>
                  <div>EN ATTENTE DE PAIEMENT</div>
                </div>
              </v-flex>
              <v-flex xs7>
                <div>A VALIDER</div>
                <div class="display-3">
                  {{
                    this.listReporting.nbDemdFAvalider.length != 0
                      ? this.listReporting.nbDemdFAvalider[0]["somme"]
                      : 0
                  }}
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>

      <v-flex xs3 class="mb-2 mr-1">

        <v-card
          color="deep-orange darken-3 darken-2"
          class="white--text elevation-5"
        >
        <h1 id="code_answer_title1" style="text-align:center;margin-bottom:8px;">FOURNISSEURS</h1>
          <v-container fluid grid-list-lg>
            <v-layout row>
              <v-flex xs5>
                <div>
                  <div class="headline">
                    {{
                      this.listReporting.nbnFacturePayrCaisse.length != 0
                        ? this.listReporting.nbnFacturePayrCaisse[0]["somme"]
                        : 0
                    }}
                  </div>
                  <div>FACTURES REGLEES</div>
                </div>
              </v-flex>
              <v-flex xs7>
                <div>FACTURES A VALIDER</div>
                <div class="display-3">
                  {{
                    this.listReporting.nbnFactuFournAvalidr.length != 0
                      ? this.listReporting.nbnFactuFournAvalidr[0]["somme"]
                      : 0
                  }}
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
       <v-flex xs3 class="mb-2 mr-1">
       <v-card color="cyan darken-2" class="white--text elevation-5">
        <h1 id="code_answer_title1" style="text-align:center;margin-bottom:8px;">MISSIONS</h1>
          <v-container fluid grid-list-lg>
            <v-layout row>
               <!-- <v-flex xs12 class="mb-2 mr-1">

               </v-flex> -->
                 <v-flex xs5>
                    <div>
                      <div class="headline">
                       {{
                          this.listReporting.nbMissionCrer.length != 0
                            ? this.listReporting.nbMissionCrer[0]["somme"]
                            : 0
                        }}
                      </div>
                      <div>CREES</div>
                    </div>
                     <div>
                      <div class="headline">
                       {{
                          this.listReporting.nbMissionClotur.length != 0
                            ? this.listReporting.nbMissionClotur[0]["somme"]
                            : 0
                        }}/{{
                          this.listReporting.nbMissionEncour.length != 0
                            ? this.listReporting.nbMissionEncour[0]["somme"]
                            : 0
                        }}
                      </div>
                      <div>CLOTUREES</div>
                    </div>
                  </v-flex>

                  <v-flex xs7>
                    <div>
                      <div class="headline">
                        {{
                          this.listReporting.nbMissionFactureAValiderr.length != 0
                            ? this.listReporting.nbMissionFactureAValiderr[0]["somme"]
                            : 0
                        }}
                      </div>
                      <div>FACTURES A VALIDER</div>
                    </div>
                     <div>
                      <div class="headline">
                       {{
                          this.listReporting.nbMissionClotur.length != 0
                            ? this.listReporting.nbMissionClotur[0]["somme"]
                            : 0
                        }}/{{
                          this.listReporting.nbMissionAconfirmer.length != 0
                            ? this.listReporting.nbMissionAconfirmer[0]["somme"]
                            : 0
                        }}
                      </div>
                      <div>A CONFIRMER</div>
                    </div>
                  </v-flex>
            </v-layout>
          </v-container>
        </v-card>
         </v-flex>

      <v-flex xs3 class="mb-2 mr-1">
        <v-card color="amber darken-4" class="white--text elevation-5">
        <h1 id="code_answer_title1" style="text-align:center;margin-bottom:8px;">TRESORERIES</h1>
          <v-container fluid grid-list-lg>
            <v-layout row>
              <v-flex xs5>
                <div>
                  <div class="headline">
                    {{
                      this.listReporting.nbnApproCaisseCrr.length != 0
                        ? this.listReporting.nbnApproCaisseCrr[0]["somme"]
                        : 0
                    }}
                  </div>
                  <div>APPROS ENREGISTRES</div>
                </div>
              </v-flex>
              <v-flex xs7>
                <div>APPROS A VALIDER</div>
                <div class="display-3">
                  {{
                    this.listReporting.nbnApproCaisseAvalider.length != 0
                      ? this.listReporting.nbnApproCaisseAvalider[0]["somme"]
                      : 0
                  }}
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout row>
      <v-flex sm9>
        <v-layout row>
          <v-flex xs4 class="mb-2 mr-1">
            <v-card color="indigo   darken-2" class="white--text elevation-5">
            <h1 id="code_answer_title1" style="text-align:center;margin-bottom:8px;">VIDANGES</h1>
              <v-container fluid grid-list-lg>
                <v-layout row>
                  <v-flex xs5>
                    <div>
                      <div class="headline">
                        {{
                          this.listReporting.nbnVidProgramr.length != 0
                            ? this.listReporting.nbnVidProgramr[0]["somme"]
                            : 0
                        }}
                      </div>
                      <div>PROGRAMMEES</div>
                    </div>
                  </v-flex>
                  <v-flex xs7>
                    <div>VISITES TECHNIQUES PROGRAMMEES</div>
                    <div class="display-3">
                      {{
                        this.listReporting.nbnVisitTechProgramr.length != 0
                          ? this.listReporting.nbnVisitTechProgramr[0]["somme"]
                          : 0
                      }}
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>
          <v-flex xs4 class="mb-2 mr-1">

            <v-card
              color="light-green accent-4"
              class="white--text elevation-5"
            >
            <h1 id="code_answer_title1" style="text-align:center;margin-bottom:8px;">ASSURANCES</h1>
              <v-container fluid grid-list-lg>
                <v-layout row>
                  <v-flex xs5>
                    <div>
                      <div class="headline">
                        {{
                          this.listReporting.nbnTotalAssurancCr.length != 0
                            ? this.listReporting.nbnTotalAssurancCr[0]["somme"]
                            : 0
                        }}
                      </div>
                      <div>CREES</div>
                    </div>
                  </v-flex>
                  <v-flex xs7>
                    <div>EXPIREES</div>
                    <div class="display-3">
                      {{
                        this.listReporting.nbnTotalAssurancExp.length != 0
                          ? this.listReporting.nbnTotalAssurancExp[0]["somme"]
                          : 0
                      }}/{{
                        this.listReporting.nbnTotalAssurancValid.length != 0
                          ? this.listReporting.nbnTotalAssurancValid
                          : 0
                      }}
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>
           <v-flex xs4 class="mb-2 mr-1">
           <v-card color="red darken-2" class="white--text elevation-5">
        <h1 id="code_answer_title1" style="text-align:center;margin-bottom:8px;">BESOINS</h1>

              <v-container fluid grid-list-lg>
                <v-layout row>
                  <v-flex xs5>
                    <div>
                      <div class="headline">
                        {{
                          this.listReporting.nbnBesoinCreer.length != 0
                            ? this.listReporting.nbnBesoinCreer[0]["somme"]
                            : 0
                        }}
                      </div>
                      <div>CREES</div>
                    </div>
                  </v-flex>
                  <v-flex xs7>
                    <div>COMMANDES FOURNISSEURS CREES</div>
                    <div class="display-3">
                      {{
                          this.listReporting.nbnComandFournCrr.length != 0
                            ? this.listReporting.nbnComandFournCrr[0]["somme"]
                            : 0
                        }}
                    </div>
                  </v-flex>

                </v-layout>
              </v-container>
            </v-card>
          </v-flex>
        </v-layout>

        <v-layout row>
           <v-flex xs4 class="mb-2 mr-1">
              <v-card color="cyan darken-2" class="white--text elevation-5">
              <h1 id="code_answer_title1" style="text-align:center;margin-bottom:8px;">PROJETS</h1>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex xs12>
                          <div>TACHES</div>
                          <v-layout row wrap>
                            <v-flex xs4>
                              <div class="display-3 font-weight-thin">
                                {{
                                  this.listReporting.nbTachesDemarer.length != 0
                                    ? this.listReporting.nbTachesDemarer[0][
                                        "somme"
                                      ]
                                    : 0
                                }}
                              </div>
                              <div class="caption font-weight-thin">EN COURS</div>
                            </v-flex>

                            <v-flex xs4>
                              <div class="display-3 font-weight-thin">
                                {{
                                  this.listReporting.nbTachesAreter.length != 0
                                    ? this.listReporting.nbTachesAreter[0][
                                        "somme"
                                      ]
                                    : 0
                                }}
                              </div>
                              <div class="caption font-weight-thin">ARRETEES</div>
                            </v-flex>

                            <v-flex xs4>
                              <div class="display-3 font-weight-thin">
                                {{
                                  this.listReporting.nbTachesTerminer.length != 0
                                    ? this.listReporting.nbTachesTerminer[0][
                                        "somme"
                                      ]
                                    : 0
                                }}
                              </div>
                              <div class="caption font-weight-thin">
                                TERMINEES
                              </div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                            <v-flex xs5>
                        <div>
                          <div class="headline">
                            {{
                              this.listReporting.nbRapportJOur.length != 0
                                ? this.listReporting.nbRapportJOur[0]["somme"]
                                : 0
                            }}
                          </div>
                          <div>RAPPORTS CHANTIERS CREES</div>
                        </div>
                      <div>
                        <div class="headline">
                          {{
                            this.listReporting.nbRapportJOurValidr.length != 0
                              ? this.listReporting.nbRapportJOurValidr[0]["somme"]
                              : 0
                          }}
                        </div>
                        <div>RAPPORTS CHANTIERS VALIDES</div>
                      </div>
                    </v-flex>
                    <v-flex xs7>
                      <div>CHANTIERS CREES</div>
                      <div class="display-3">
                        {{
                          this.listReporting.nbChantierCrer.length != 0
                            ? this.listReporting.nbChantierCrer[0]["somme"]
                            : 0
                        }}
                      </div>
                    </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card>
            </v-flex>


          <v-flex xs8 class="text-xs-center pr-2 ml-2">
            <v-card class="elevation-5 pl-2 pt-2">
              <h4>
                UTILISATEURS CONNECTES AUJOURD'HUI
                <v-chip outline color="red"> {{this.listeUsers ? this.listeUsers.length : 0 }}/{{ this.listReporting.nbnTotalUsr -1}}</v-chip>
              </h4>
              <v-divider class="mb-1"></v-divider>
              <el-table :data="listeUsers" height="350" style="width: 100%">
                <el-table-column prop="nom" label="Nom  Prénom(s)">
                  <template slot-scope="scope">
                    <el-tag class="body-2">{{ scope.row.name }}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="tpsMoyen" label="Fonction">
                  <template slot-scope="scope">
                    <span class="green--text title">{{
                      scope.row.fonction
                    }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex sm3>
        <v-layout row>
          <v-flex xs12 class="mb-2 mr-1">
            <v-card color="blue darken-2" class="white--text elevation-5">
            <h1 id="code_answer_title1" style="text-align:center;margin-bottom:8px;">PARC AUTO</h1>

              <v-container fluid grid-list-lg>
                <v-layout row wrap>
                  <v-flex xs12>
                    <div>VEHICULES</div>
                    <v-layout row wrap>
                      <v-flex xs4>
                        <div class="display-3 font-weight-thin">
                          {{
                            this.listReporting.nbnTotalVehciulCrér.length != 0
                              ? this.listReporting.nbnTotalVehciulCrér[0][
                                  "somme"
                                ]
                              : 0
                          }}
                        </div>
                        <div class="caption font-weight-thin">CREES</div>
                      </v-flex>

                      <v-flex xs4>
                        <div class="display-3 font-weight-thin">
                          {{
                            this.listReporting.nbnTotalVehciulPanne.length != 0
                              ? this.listReporting.nbnTotalVehciulPanne[0][
                                  "somme"
                                ]
                              : 0
                          }}
                        </div>
                        <div class="caption font-weight-thin">EN PANNES</div>
                      </v-flex>

                      <v-flex xs4>
                        <div class="display-3 font-weight-thin">
                          {{
                            this.listReporting.nbnTotalVehciulReparation.length != 0
                              ? this.listReporting.nbnTotalVehciulReparation[0][
                                  "somme"
                                ]
                              : 0
                          }}
                        </div>
                        <div class="caption font-weight-thin">
                          EN REPARATIONS
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs12 class="mb-2 mr-1">
            <v-card color="orange  darken-2" class="white--text elevation-5">
              <v-container fluid grid-list-lg>
                <v-layout row>
                  <v-flex xs7>
                    <div>
                      <div class="display-2">
                        {{
                          this.listReporting.nbnTotalDemandeReparation.length != 0
                            ? this.listReporting.nbnTotalDemandeReparation[0]["somme"]
                            : 0
                        }}
                      </div>
                      <div>DEMANDES DE REPARATIONS CREES</div>
                    </div>
                    <div>
                      <div class="display-2">
                        {{
                          this.listReporting.nbnApproCaisseCrr.length != 0
                            ? this.listReporting.nbnApproCaisseCrr[0]["somme"]
                            : 0
                        }}
                      </div>
                      <div>APPROVISIONNEMENTS CARBURANT ENREGISTRES</div>
                    </div>
                  </v-flex>
                  <v-flex xs5>
                    <div>MONTANT CONSOMMATION CARBURANT</div>
                    <div class="display-2">
                      {{
                        this.listReporting.nbMontanConsomCarb.length != 0
                          ? this.listReporting.nbMontanConsomCarb[0]["total"]
                          : 0
                      }} XOF
                    </div>
                  </v-flex>
                </v-layout>

                <v-layout row>
              <v-flex xs5>
                <div>
                  <div class="headline">
                    {{
                      this.listReporting.nbnBonSortiCrr.length != 0
                        ? this.listReporting.nbnBonSortiCrr[0]["somme"]
                        : 0
                    }}
                  </div>
                  <div>BONS DE SORTI CREES</div>
                </div>
              </v-flex>
              <v-flex xs7>
                <div>BONS DE SORTI VALIDES</div>
                <div class="display-3">
                  {{
                    this.listReporting.nbnBonSortiValidr.length != 0
                      ? this.listReporting.nbnBonSortiValidr[0]["somme"]
                      : 0
                  }}
                </div>
              </v-flex>
              </v-layout>
              </v-container>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout row> </v-layout>
  </div>
</template>

<script>
import Loading from "@/components/Loading";

export default {
  components: {
    Loading
  },
  name: "dashboardReporting",
  data() {
    return {
      //data general
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      racourcis: [
        { path: "/", text: "Accueil", disabled: false },
        {
          path: "/dashboardReporting",
          text: "Dashboard reporting",
          disabled: true
        }
      ],

      listeUsers: [
         {
            nom: "",
            fonction: ""
        },
      ],
      listReporting: []
    };
  },

  methods: {
    imprimeListeBilan() {
      let url = this.domaine+"userCreate/imprimerBilandDG/"+this.user.id
      window.open(url)
    },
    loadBilanDg() {
      // this.loading = true;
      let url = this.domaine + "userCreate/index/reporting/semaine";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listReporting = response.body;
          this.listeUsers = this.listReporting.listeUserConecter
          this.loading = false;
        }
      });
    }
  },
  mounted() {
    this.loadBilanDg();
  }
};
</script>

<style scoped>
  .tooltip-btn {
    position: relative;
    color: white;
  }

  .tooltip-btn::after {
    content: attr(title);
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    padding: 5px;
    border-radius: 5px;
    white-space: nowrap;
    opacity: 0;
    visibility: hidden;
    color: white;
    transition: opacity 0.9s, visibility 0.9s;
  }

  .tooltip-btn:hover::after {
    opacity: 1;
    visibility: visible;
  }
</style>



// WEBPACK FOOTER //
// src/components/reporting/dashboardReporting.vue